import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React, { useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { KeypadContext, ReadAloudController } from '@3plearning/question-components-library';
import css from './activity.scss';
import { MODULE_NAME_ACTIVITY } from '../../helpers/constants';
import Conquest from '../conquest/conquest';
import {
  enableSpinner,
  ACTIVITY_RENDER_SPINNER
} from '../mle/mle-actions';
import { ErrorBoundary } from '../../components/errors';
import { Keypad } from '../conquest/keypad';

const Activity = ({ readAloudConfig }) => {
  const dispatch = useDispatch();
  const initMleReducer = useSelector(state => state.initMleReducer);
  const activityData = initMleReducer.find(item => item.meta.name === MODULE_NAME_ACTIVITY);
  const {
    questionBodyRef
  } = useContext(KeypadContext);

  useEffect(() => {
    dispatch(enableSpinner(ACTIVITY_RENDER_SPINNER));
  }, []);

  return (
    <div className={css.activity}>
      <Box position="absolute" top="20px" left="-20px" zIndex="95">
        <ReadAloudController
          readAloudConfig={readAloudConfig}
          containerId="new-content-container"
        />
      </Box>
      <Keypad />
      <Box position="relative" height="100%" overflow="hidden" borderRadius="16px 16px 0 0">
        <div className={css['inner-scroll']} ref={questionBodyRef}>
          {
            activityData && (
              <ErrorBoundary>
                <Conquest />
              </ErrorBoundary>
            )
          }
        </div>
      </Box>
    </div>
  );
};

Activity.propTypes = {
  readAloudConfig: PropTypes.object.isRequired
};

export default Activity;
